import React from 'react'

// Navbar, Footer & Product
import { Product } from "../components"


/*
=======================
Individual Product Page 
=======================
*/


const Products = () => {
  return (
    <>
      {/* <Navbar /> */}
      <Product />
      {/* <Footer /> */}
    </>
  )
}

export default Products